import congrats from './congrats.vue';

export default congrats;
